export default __webpack_public_path__ + "static/teaching-cb3b7ca95517c2871cf8d9028b852822.png";